import React from 'react'
import { Overlay, Popover, Stack } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import langList from '../../utils/languagelist.json';

export default function Alertwin(p) {
  const { nu:{target,place,title,mark} }=p
  const show=title ? true : false;
  const {lg}=useSelector((state)=>state.language);

  let svgAddress='cup-hot.svg'
  switch (mark) {
    case 1:
      svgAddress='cup-hot.svg'
      break;
    case 2:
      svgAddress='exclamation-circle.svg'
      break;
    case 3:
      svgAddress='check-lg.svg'
      break;
    default:
      svgAddress='cup-hot.svg'
      break;
  }  

  return (
    <Overlay target={target} show={show} placement={place}>
      {(props) => (
        <Popover {...props}>
          <Popover.Header as="h3">{langList.tabbr6[lg]}</Popover.Header>
          <Popover.Body>
          <Stack direction="horizontal" gap={2}>
            <div><img src={`./pic/${svgAddress}`} alt='' width={'20px'} height={'20px'}/></div>
            <div>{title}</div>
          </Stack>
          </Popover.Body>
        </Popover>
      )}
    </Overlay>
  )
};

